module.exports = __webpack_public_path__ + "static/media/stat.7a7c024d.png";